import CircularProgress from "@material-ui/core/CircularProgress";

const LoadingPageComponent = () => {

    return (
        <div>Trwa ładowanie strony...<CircularProgress color={"secondary"} size={20} /></div>
    );
};



export default LoadingPageComponent;